<template>
  <div style='position:absolute;' id="basiccontrols">
    <el-menu default-active="1" class="el-menu-vertical-demo" mode='vertical'>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">显示</span>
        </template>
        <el-submenu index="1-1">
          <span slot="title">道路控制</span>
          </el-menu-item>
          <el-menu-item index="1-1-1">
            <el-switch active-color="#13ce66" active-text-color="#13ce66"  v-model="basicParam.showVerticalSection" @change='onSwitchShowVerticalSection' active-text="显示纵断面">
            </el-switch>
          </el-menu-item>
          <el-menu-item index="1-1-2">
            <el-switch active-color="#13ce66" active-text-color="#13ce66" v-model="basicParam.showMap" @change='onSwitchShowMap' active-text="显示地图">
            </el-switch>
          </el-menu-item>
          <el-menu-item index="1-1-3">
            <el-switch active-color="#13ce66" active-text-color="#13ce66" v-model="basicParam.showRoadData" @change='onSwitchShowRoadData' active-text="显示横断面">
            </el-switch>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="1-2">
          <span slot="title">视图</span>
          <el-menu-item index="1-2-1">
            <el-switch active-color="#13ce66" active-text-color="#13ce66" v-model="basicParam.showCoord" @change='onSwitchCoordsChanged' active-text="显示坐标轴">
            </el-switch>
          </el-menu-item>
          <el-menu-item index="1-2-2">
            <el-switch active-color="#13ce66" active-text-color="#13ce66" inactive-color="#ff4949" v-model="basicParam.showWireframe" @change='onSwitchWireframe' active-text="线框图" inactive-text="影像图">
            </el-switch>
          </el-menu-item>
        </el-submenu>
      </el-submenu>
       <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span slot="title">控制</span>
        </template>
        <el-menu-item index="2-1" @click='simulateNavi' >模拟驾驶</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
  import {CoordCommand} from './commands/CoordCommand.js'
  import {ShowStationMarkCommand} from './commands/ShowStationMarkCommand.js'
  import {ShowRoadDataCommand} from './commands/ShowRoadDataCommand.js'
  import {ShowVerticalSectionCommand} from './commands/ShowVerticalSectionCommand.js'
  import {ShowMapCommand} from './commands/ShowMapCommand.js'
  import {NavControllCommand} from './commands/NavControllCommand.js'
export default {
  name: 'ViewBasicControl',
  data() {
    return {
        basicParam: {
        showCoord: false,
        showStation: false,
        showRoadData: false,
        showVerticalSection: false,
        showMap:true,
        showWireframe:true
      }
    }
  },
  methods: {
    onSwitchCoordsChanged: function(e) {
      var eventArg = {'command': new CoordCommand(e)};
      this.$emit("menuCommand", eventArg);
    },
    onSwitchShowStation: function(e) {
      var eventArg = {'command': new ShowStationMarkCommand(e)};
      this.$emit("menuCommand", eventArg);
    },
    onSwitchShowRoadData : function(e){
      var eventArg = {'command': new ShowRoadDataCommand(e)};
      this.$emit("menuCommand", eventArg);
    },
    simulateNavi : function(e){
      var eventArg = {'command': new NavControllCommand(-1, this.$parent.$refs.navControlPanel)};
      this.$emit("menuCommand", eventArg);
    },
    onSwitchShowVerticalSection : function(e){
      var eventArg = {'command': new ShowVerticalSectionCommand(e)};
      this.$emit("menuCommand", eventArg);
    },
    onSwitchShowMap : function(e){
      var eventArg = {'command': new ShowMapCommand(e)};
      this.$emit("menuCommand", eventArg);
    },
    onSwitchWireframe : function(e){
        this.$parent.sceneManager.swithEarthPlane(e);
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
}

</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/ViewBasicControls.vue